/**
 * @title quick-view.js: Sub-module of Browse feature
 * @description This module encapsulates all of the
 * functionality related to the quick view component of product display.
 * @dependency dialog.js, checkout_helper.js, mathtable.js, zoom-viewer.js
 */
 define(['mathtable','zoomViewer'], function(CMath,ZoomViewer) {
  var QuickView = {
    
    /**
     * Opens Quick View modal.
     * @param {Object} event Triggered event on user click.
     */
    openQuickViewModal: function(event, partNumber, statusIndex, isBrandfolderEnabled) {
      
      let currentWindowPosition = $(window).scrollTop();
      //STRY0143953- Changes for 2-Day Depot Item Quick View
      let isTwoDayItem = $("#isTwoDayItem_"+partNumber).val();
      let inStock = $("#in_Stock_"+partNumber).val();
      let isProductfsaChdAttr = $("#productfsaChdAttr_"+partNumber).val();
      
      COSTCO.dialog.createExtDialogBox({
        title: messages.QUICK_VIEW__Modal_Title,
        body: COSTCO.util.tmpl('tmpl_spinner',{}),
        hideFooter: true,
        dialogclasses: 'medium quick-view-modal',
        onshow: function() {
         if(!isBrandfolderEnabled) {
           $(window).on('scroll', {position: currentWindowPosition}, COSTCO.ZoomViewer.lockWindowScrolling);
           $(window).on('error', COSTCO.ZoomViewer.reloadThumbnailsOnScriptError);
          }
          $('body').addClass('quick-view-modal-open');
        },
        onclose: function() {
          if(!isBrandfolderEnabled) {
          ZoomViewer.cleanupEvents();
          ZoomViewer.resetLiveclicker();
          RICHFX.load.fullReset();
          //reset Liveclicker indexing
          RICHFX.media.iRegObjsCount = 0;
          
          $(window).off('scroll', COSTCO.ZoomViewer.lockWindowScrolling);
          $(window).off('error', COSTCO.ZoomViewer.reloadThumbnailsOnScriptError);
          } 
          $('body').removeClass('quick-view-modal-open');
          $(event.currentTarget).focus();
        }
      });
      
      COSTCO.Checkout.ajax_update_state({
        method: 'POST',
        url: '/AjaxProductQuickView',
        data: {
        	'partNumber': partNumber,
        	'isTwoDayItem':isTwoDayItem,
        	'isProductfsaChdAttr':isProductfsaChdAttr,
        	'inStock':inStock
        },
        dataType: 'json',
        ajax_update_post_done: function(data, textStatus, jqXHR, options) {
          COSTCO.CMath.init();
          if(isBrandfolderEnabled) {
        	  window.eventBus.publish('initializeAfterload','.quickView_selector');
          } else {        	
	          document.addEventListener('richmedia.state.loaded', COSTCO.ZoomViewer.richMediaLoaded);
	          document.addEventListener('richmedia.view.changed', COSTCO.ZoomViewer.richMediaViewChange);
	          document.addEventListener('richmedia.swatch.changed', COSTCO.ZoomViewer.richMediaSwatchChange);
	          ZoomViewer.initZoomViewer();
	          RICHFX.init();
          }
 
          $('.co-help').popover();
          $('#ProductForm #minQtyText').unbind().on('keypress', function(event) {
            if (event.keyCode === 13) {
              QuickView.addToCart(event, statusIndex);
              return false;
            }
          });
          $("#ProductForm input[name='add-to-cart']").unbind().click(function () {
            QuickView.addToCart(event, statusIndex);
          });
        }
      });
    },
    
    /**
     * Triggers Add to Cart on modal window.
     * if already added to cart, update quantity by 1
     * else update by the quantity indicated in quick view
     * @param {Object} event Triggered event on user click.
     * @param {int} statusIndex Index of an item on html page.
     */
    addToCart: function(event, statusIndex) {
      event.preventDefault();
      const addButton = $('#addbutton-'+ statusIndex);
      if(addButton.hasClass('disabled')){
    	  COSTCO.dialog.close();
    	  $('#costcoModal').on('hidden.bs.modal', function () {
        	  $('#add-' + statusIndex).trigger('click');
    	  });
      } else {
    	  $('#value-' + statusIndex).val($('#minQtyText').val());
          COSTCO.dialog.close();
          $('#costcoModal').on('hidden.bs.modal', function () {
        	  $(addButton).trigger('click');
          });
      }
    },
  }
  
  if (typeof window.COSTCO == 'undefined') {
    window.COSTCO = new Object();
  }
  
  window.COSTCO.QuickView = QuickView;
  
  return QuickView;
});



// WEBPACK FOOTER //
// ./js/browse/quick-view.js